import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon' | 'white';
}

export const HumanRisksLogo: React.FC<LogoProps> = ({ className = 'h-8', variant = 'full' }) => {
  const isWhite = variant === 'white';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg viewBox="0 0 100 60" className="h-full w-auto overflow-visible" fill="none">
        {/* Figure 1 (Indigo) */}
        <circle cx="25" cy="20" r="15" fill={isWhite ? '#FFFFFF' : '#1E1246'} />
        <path d="M5 60 C 5 35, 45 35, 45 60 Z" fill={isWhite ? '#FFFFFF' : '#1E1246'} />

        {/* Figure 2 (Pink) */}
        <g style={{ mixBlendMode: isWhite ? 'normal' : 'multiply', opacity: isWhite ? 0.8 : 1 }}>
          <circle cx="45" cy="25" r="15" fill="#D31054" />
          <path d="M25 60 C 25 40, 65 40, 65 60 Z" fill="#D31054" />
        </g>
      </svg>
      {variant !== 'icon' && (
        <div className="flex flex-col">
          <span
            className={`font-black text-lg tracking-tighter leading-none ${isWhite ? 'text-white' : 'text-hr-indigo'}`}
          >
            HUMAN
          </span>
          <span
            className={`font-black text-micro tracking-[0.4em] leading-none ${isWhite ? 'text-hr-pink' : 'text-slate-500'}`}
          >
            RISKS
          </span>
        </div>
      )}
    </div>
  );
};
